// extracted by mini-css-extract-plugin
module.exports = {"container":"_5AUMt6","prizes":"_1ny9z7","text":"_1ZKbZ5","title":"_1BQCl2"};